module.exports = __webpack_public_path__ + "img/banner2_7_kr.b397c999.png";